const selectKitComponentIndexOption = /* GraphQL */ `
  query SelectKitComponentIndexOption(
    $skuBase: String!
    $skuVariant: String
    $selectedIndexOptions: [Int!]
    $lastSelectedOption: Int
  ) {
    selectKitComponentIndexOption(
      skuBase: $skuBase
      skuVariant: $skuVariant
      selectedIndexOptions: $selectedIndexOptions
      lastSelectedOption: $lastSelectedOption
    ) {
      id
      ordinality
      displayName
      skuVariantNumber
      availability
      availabilityDisplayCopy
      isPurchaseable
      indexOptionValues {
        id
        ordinality
        isSelected
        isDisabled
        displayName
        isPurchaseable
        url
      }
    }
  }
`

export default selectKitComponentIndexOption
